import { render } from "./SentTokenBids.vue?vue&type=template&id=1ef141ec"
import script from "./SentTokenBids.vue?vue&type=script&lang=js"
export * from "./SentTokenBids.vue?vue&type=script&lang=js"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__